import React, { useEffect, useRef } from "react";
import videoSource from "../../images/timeline.mp4";
import "./index.css";

const HeroVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensuring the video plays even if the browser tries to throttle it
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Autoplay was prevented:", error);
      });
    }
  }, []);

  return (
    <div className="hero__right">
      <div className="hero__video-container">
        <video
          ref={videoRef}
          className="hero__video-element"
          src={videoSource}
          autoPlay
          muted
          loop
          playsInline
          draggable="false"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default HeroVideo;
